var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("MatchMedia", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ mobile }) {
          return [
            _c(
              "div",
              [
                _c("Core-Title", [_c("h2", [_vm._v("Iniciar proceso A1-38")])]),
                _c("p", { staticClass: "description" }, [
                  _vm._v("Puesta en Servicio Nuevos Suministros"),
                ]),
                _c(
                  "div",
                  { staticClass: "content" },
                  [
                    !mobile
                      ? _c(
                          "el-steps",
                          {
                            attrs: {
                              active: _vm.currentStep,
                              "align-center": "",
                              direction: "vertical",
                            },
                          },
                          [
                            _c("el-step", {
                              attrs: {
                                title: "Solicitud",
                                icon: "el-icon-tickets",
                              },
                            }),
                            _c("el-step", {
                              attrs: {
                                title: "Punto de suministro 1",
                                icon: "el-icon-map-location",
                              },
                            }),
                            _c("el-step", {
                              attrs: {
                                title: "Punto de suministro 2",
                                icon: "el-icon-map-location",
                              },
                            }),
                            _c("el-step", {
                              attrs: {
                                title: "Cliente 1",
                                icon: "el-icon-user",
                              },
                            }),
                            _c("el-step", {
                              attrs: {
                                title: "Cliente 2",
                                icon: "el-icon-user",
                              },
                            }),
                            _c("el-step", {
                              attrs: {
                                title: "Cliente 3",
                                icon: "el-icon-user",
                              },
                            }),
                            _c("el-step", {
                              attrs: {
                                title: "Instalación",
                                icon: "el-icon-setting",
                              },
                            }),
                            _c("el-step", {
                              attrs: {
                                title: "Observaciones",
                                icon: "el-icon-view",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "steps-content" },
                      [
                        _c(
                          "el-card",
                          [
                            _c("ProcessesForms-InitialForm", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.currentStep === 0,
                                  expression: "currentStep === 0",
                                },
                              ],
                              on: { submit: _vm.onSubmitForm },
                            }),
                            _c(
                              "ProcessesForms-SupplyPointForm1",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.currentStep === 1,
                                    expression: "currentStep === 1",
                                  },
                                ],
                                on: { submit: _vm.onSubmitForm },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "return-button",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        _vm.currentStep--
                                      },
                                    },
                                  },
                                  [_vm._v("Atrás")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "ProcessesForms-SupplyPointForm2",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.currentStep === 2,
                                    expression: "currentStep === 2",
                                  },
                                ],
                                on: { submit: _vm.onSubmitForm },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "return-button",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        _vm.currentStep--
                                      },
                                    },
                                  },
                                  [_vm._v("Atrás")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "ProcessesForms-ClientForm1",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.currentStep === 3,
                                    expression: "currentStep === 3",
                                  },
                                ],
                                on: { submit: _vm.onSubmitForm },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "return-button",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        _vm.currentStep--
                                      },
                                    },
                                  },
                                  [_vm._v("Atrás")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "ProcessesForms-ClientForm2",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.currentStep === 4,
                                    expression: "currentStep === 4",
                                  },
                                ],
                                on: { submit: _vm.onSubmitForm },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "return-button",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        _vm.currentStep--
                                      },
                                    },
                                  },
                                  [_vm._v("Atrás")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "ProcessesForms-ClientForm3",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.currentStep === 5,
                                    expression: "currentStep === 5",
                                  },
                                ],
                                on: { submit: _vm.onSubmitForm },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "return-button",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        _vm.currentStep--
                                      },
                                    },
                                  },
                                  [_vm._v("Atrás")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "ProcessesForms-InstallationForm",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.currentStep === 6,
                                    expression: "currentStep === 6",
                                  },
                                ],
                                on: { submit: _vm.onSubmitForm },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "return-button",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        _vm.currentStep--
                                      },
                                    },
                                  },
                                  [_vm._v("Atrás")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "ProcessesForms-ObservationsForm",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.currentStep === 7,
                                    expression: "currentStep === 7",
                                  },
                                ],
                                on: { submit: _vm.onFinalSubmit },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "return-button",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        _vm.currentStep--
                                      },
                                    },
                                  },
                                  [_vm._v("Atrás")]
                                ),
                              ],
                              1
                            ),
                            _vm.currentStep === 8
                              ? _c("ProcessesForms-CreationResult", {
                                  attrs: {
                                    validationErrors: _vm.errors,
                                    validationResult: !_vm.errors.length,
                                    loading: _vm.loading,
                                  },
                                  on: {
                                    onReturn: function ($event) {
                                      _vm.currentStep--
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }